
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MasterLicenseGeneralSettingsTab from './MasterLicenseGeneralSettingsTab';
import PaymentsSettingsTab from './PaymentsSettingsTab';
import MasterLicenseSecurityTab from './MasterLicenseSecurityTab';
import TremendousSettingsTab from './TremendousSettingsTab';
import RevenueSettingsTab from './RevenueSettingsTab';
import EmailSettingsTab from './EmailSettingsTab';
import RewardIntegrationsTab from './RewardIntegrationsTab';
import SEOReportsTab from './SEOReportsTab';
import WebPagesTab from './WebPagesTab';
import AISettingsTab from './AISettingsTab';
import { Sparkles } from 'lucide-react';

interface MasterLicenseSettingsTabContainerProps {
  isLoading: boolean;
  onSaveSettings: (section: string) => void;
}

const MasterLicenseSettingsTabContainer: React.FC<MasterLicenseSettingsTabContainerProps> = ({
  isLoading,
  onSaveSettings,
}) => {
  const [activeTab, setActiveTab] = useState('general');

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="grid grid-cols-2 md:grid-cols-5 lg:grid-cols-10 mb-8">
        <TabsTrigger value="general">General</TabsTrigger>
        <TabsTrigger value="payments">Payments</TabsTrigger>
        <TabsTrigger value="security">Security</TabsTrigger>
        <TabsTrigger value="revenue">Revenue</TabsTrigger>
        <TabsTrigger value="email">Email</TabsTrigger>
        <TabsTrigger value="rewards">Rewards</TabsTrigger>
        <TabsTrigger value="ai" className="flex items-center gap-1">
          <Sparkles className="h-3 w-3" />
          AI
        </TabsTrigger>
        <TabsTrigger value="seo">SEO</TabsTrigger>
        <TabsTrigger value="web">Web Pages</TabsTrigger>
        <TabsTrigger value="tremendous">Tremendous</TabsTrigger>
      </TabsList>

      <TabsContent value="general" className="p-4 bg-white rounded-md">
        <MasterLicenseGeneralSettingsTab />
      </TabsContent>

      <TabsContent value="payments" className="p-4 bg-white rounded-md">
        <PaymentsSettingsTab />
      </TabsContent>

      <TabsContent value="security" className="p-4 bg-white rounded-md">
        <MasterLicenseSecurityTab />
      </TabsContent>

      <TabsContent value="revenue" className="p-4 bg-white rounded-md">
        <RevenueSettingsTab />
      </TabsContent>

      <TabsContent value="email" className="p-4 bg-white rounded-md">
        <EmailSettingsTab />
      </TabsContent>

      <TabsContent value="rewards" className="p-4 bg-white rounded-md">
        <RewardIntegrationsTab />
      </TabsContent>

      <TabsContent value="ai" className="p-4 bg-white rounded-md">
        <AISettingsTab onSaved={() => onSaveSettings('ai')} />
      </TabsContent>

      <TabsContent value="seo" className="p-4 bg-white rounded-md">
        <SEOReportsTab />
      </TabsContent>

      <TabsContent value="web" className="p-4 bg-white rounded-md">
        <WebPagesTab />
      </TabsContent>

      <TabsContent value="tremendous" className="p-4 bg-white rounded-md">
        <TremendousSettingsTab />
      </TabsContent>
    </Tabs>
  );
};

export default MasterLicenseSettingsTabContainer;
